  <template >
<div>

 <div v-role="'est'"  class="formPosition">
 <template>
  <v-container   class="grey lighten-5">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
     <v-row >
      <v-col md="12">

<div  class="text-center">
 <!-- {{new Date()}} -->
  <div 
      v-if="$store.state.hasMessage"
      :class="$store.state.classMessage"
    >{{$store.state.textMessage}}</div>
     <h4 style="color:orange;float:right;font-size:20px;">Avalie os nossos serviços clicando<v-btn text color="green" @click="avaliarSistema()" >Aqui</v-btn></h4>
    <h5 style="float:left;">Nossos Contactos:</h5><br>
    <span style="float:left;">948 105 702</span><br>
   <span style="float:left;">contacto.softline@gmail.com</span>
<div   :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
  <template>

             <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="590"
    >
      <v-card>
        <v-card-title class="text-h5">
          Dialogo de confirmação
        </v-card-title>
        <v-card-text>Deseja continuar com a operação ? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="Continuar()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  </template>
    <span  class="hidden-md-and-up pb-0" style="font-size:14px">  {{  instituicaodescricao }}</span> <br>
    <span   style="font-size:14px" > Anolectivo:  {{  anolectivo}}</span><br>
    <span  style="font-size:14px">   {{loggedUserName}} {{role}}  </span>

    <br>
    <br>
    <h2> Bem vindos ao  sistema Eltsys </h2>
    <br>
    <br>
       <p v-if="!$browserDetect.isChrome" >Você está a utilizar o navegador : <strong> {{$browserDetect.meta.name}} versão {{$browserDetect.meta.version}}</strong></p>
      <h3 v-if="!$browserDetect.isChrome"> Aconselhamos vivamente que utilize o navegador Google Chrome -  <a href="https://www.google.pt/intl/pt-PT/chrome/" target="blank">Clique para instalar</a></h3>
      <h4 style="color:green;">A softline  passa a utilizar somente o chat como canal de comunicação.</h4>
      <h4 style="color:red;" v-if="(funcionario != null && (role_ == 'ROLE_DIR' || role_ == 'ROLE_ADM') && idInstituicao != funcionario[0].idinstituicao )"> (O) A Sr(a). Director(a) não está na sua instituição, por favor clique <v-btn text color="primary" @click="MudarInstuicaoNovo()" >Aqui</v-btn> para voltar. </h4>
      <h4 style="color:red;" v-if="(30-diasCounter) >=0 && ((30-diasCounter) <=5)" > A sua  conta vai  ficar inactivada dentro de <span style="color:black;"> {{(30-diasCounter)}} dias </span> caso não actualize a sua senha,  clique  <v-btn text color="primary" @click="MudarSenhaPerfil()" >Aqui</v-btn>  para actualizar a evitar o corte.  </h4>
  </div>
      </v-col>

    <v-col md="12">
      <v-alert v-if="items.length"
      v-model="alert"
      dismissible
      color="cyan"
      border="left"
      elevation="2"
      colored-border
      icon="info"
    >
        <span  v-for="(item, i) in items" :key="i">
           <span>{{i+1}}. Você garantiu acesso de Administrador ao usuário  <span style="font-weight:bold;">{{item.usuario}}  </span>  </span> <button @click="MostrarDialogo(item)" style="color:red">  Remover acesso</button><br>
      </span>
      
    </v-alert>
    </v-col>
    </v-row>
  </v-container>
  </template>
   </div>
</div>
</template>

<script>

   

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {

  data: () => ({
    inc: 1,
     alert: true,
     dialog: false,  
    items: [],
    overlay: false,
    objecto: null,
    funcionario: null,
    data_logged:null,
    diasCounter:null,
    path: '',
    showPub: ls.get('showPublicity')

  }),

  computed: {

    bigText () {
      return "<iframe allowfullscreen='true' width='100%' height=100% src="+this.path+" title='W3Schools Free Online Web Tutorials'></iframe>"
   },

   
   publicity (){
     return ls.get('publicity')
   },

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },

    MostrarPublicidade (){
      return ls.get('closePublicidade')
    },

    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    idInstituicao (){
      return ls.get('i_id')
    },

    idPessoa(){
      return ls.get('idPessoa')
    },

    role_ (){
      return ls.get('role')
    },

    
   
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }else if (ls.get('role') === 'ROLE_SEC') {
        rl = 'logado como Secretário(a) Pedagógico(a)'
      }
      return rl
    },
    logged_date_control () {
      return ls.get('logged_date_control')
    },
    
  },

  created () {
    this.actualizaToken();
    this.InstituicaoProveniente()
    this.ObterCursoCoordenador()
    this.ObterAcessosDados()
    this.ActualizarDataLogado_()
  
  },

  

  methods: {


    setPath () {
      this.overlay = true
      setTimeout(() => {
        this.overlay = false
        this.path = this.publicity
      }, 2000);
    },


    async actualizaToken (){
      try {
        // eslint-disable-next-line no-unused-vars
          let result = await axios
            .post('/actualizaToken')
            .then(res => res.data)
        } catch (error) {

        }
    },

    async InstituicaoProveniente (){
      try {
        // eslint-disable-next-line no-unused-vars
          this.funcionario = await axios
            .post('/ObterInstituicaoProveniencia', {idPessoa:this.idPessoa})
            .then(res => res.data)
        } catch (error) {

        }
    },


    async ActualizarDataLogado_ (){

        this.data_logged = ls.get('logged_date_control')
        this.diasCounter = utilitarios.NumberOfDayLeft(this.data_logged,utilitarios.ObterDataActual())
      
    },

     MostrarDialogo (item){
       this.objecto = item
       this.dialog = true
     },

     avaliarSistema () {
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" src="https://docs.google.com/forms/d/e/1FAIpQLSfoMX9rkI7ylx8kYy98yIw2t_V5cnSExd2Awto5fP3_sm4V3w/viewform?usp=sf_link"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },

     MudarSenhaPerfil (){
       this.$router.push('perfil')
       this.$store.state.tabPerfil = 1
     },
      
    async  GetUserLocation () {
      this.$getLocation()
        .then(coordinates => {
          let location = Object.values(coordinates)

          let valores = location.toString().split(',')
          let latitude = valores[0]
          let longitude = valores[1]

          this.LoginlogsInsert(longitude, latitude)
        })
    },

    closePublicity () {
      this.overlay = true
      setTimeout(() => {
        ls.set('showPublicity',false)
        this.path = ''
        this.showPub = false
        this.overlay = false
      }, 1000);
    },

    async   ObterDataTimeRemote () {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero (data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    async ObterCursoCoordenador () {
      if (ls.get('role') === 'ROLE_COOR') {
        try {
        // eslint-disable-next-line no-unused-vars
          let result = await axios
            .post('/obterCursoCoordenador')
            .then(res => res.data)
          if (result.length) {
            ls.set('idCursoCoordenador', result[0].idCurso)
          }
        } catch (error) {

        }
      }
    },


    async   MudarInstuicaoNovo () {
      this.dialog = false

      // this.editedItem=item
      const ls = require('local-storage')

      var params = {
        id: this.funcionario[0].idinstituicao,
        descricao: (this.funcionario[0].idinstituicao === 5)?'Softline':'EFTSLuanda'
      }

      try {
        let msg = await axios
          .post('/mudarInstituicao', params)
          .then(res => res.data)
        ls.set('i_id', this.funcionario[0].idinstituicao)
        // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
          // this.Controlo_actividade()
        } catch (error) {}
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        setTimeout(() => {
          this.logout()
        }, 1000)
      }
    },

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },


    async ObterAcessosDados () {
      if(ls.get('role') === 'ROLE_PED'){
        try {
        // eslint-disable-next-line no-unused-vars
         this.items  = await axios
            .get('/listarAcessoDados')
            .then(res => res.data)
        } catch (error) {

        }
      }
    
    },

    async LoginlogsInsert (longitude, latitude) {
      let dtt = await this.ObterDataTimeRemote()
      const params =
      {
        loginUpdate: 0,
        username: ls.get('idPessoa'),
        nome: ls.get('nomeUsuario'),
        datain: dtt,
        dataout: '',
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: ls.get('instituicaodescricao'),
        role: ls.get('role'),
        latitude: 'latitude',
        longitude: 'longitude'

      }

      // consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
    },
    async Continuar (){
      this.dialog = false
      this.overlay = true
        const params =
        {
           item: this.objecto
        }
        try {
          // eslint-disable-next-line no-unused-vars
          let msg = await axios
            .post('/removerAcessoInstituicao', params)
            .then(res => res.data)
          if(msg.affectedRows >= 0){
             this.$store.dispatch('textMessage', {
              msg: 'Acesso removido com sucesso',
              classMessage: 'msgSucess',
              timeout: 4000
            })
          }
          this.ObterAcessosDados()
          this.overlay = false
        } catch (error) {

        }
    },
    showServicos () {
      this.$router.push('mais-servicos')
    }
  }
}
</script>
